/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { ThemeDto } from '../models/theme-dto';


/**
 * Fonctions de gestion des thèmes
 */
@Injectable({
  providedIn: 'root',
})
export class ThemesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation themeGetList
   */
  static readonly ThemeGetListPath = '/api/themes/list';

  /**
   * Renvoie la liste des thèmes.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `themeGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  themeGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<ThemeDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ThemesService.ThemeGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ThemeDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des thèmes.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `themeGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  themeGetList(params?: {
  }): Observable<Array<ThemeDto>> {

    return this.themeGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ThemeDto>>) => r.body as Array<ThemeDto>)
    );
  }

  /**
   * Path part for operation themeLoadList
   */
  static readonly ThemeLoadListPath = '/api/themes/load-list';

  /**
   * Renvoie la liste des thèmes (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `themeLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  themeLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, ThemesService.ThemeLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des thèmes (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `themeLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  themeLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.themeLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation themeGet
   */
  static readonly ThemeGetPath = '/api/themes/{id}';

  /**
   * Renvoie le thème spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `themeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  themeGet$Response(params: {

    /**
     * Identifiant du thème
     */
    id: number;
  }): Observable<StrictHttpResponse<ThemeDto>> {

    const rb = new RequestBuilder(this.rootUrl, ThemesService.ThemeGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ThemeDto>;
      })
    );
  }

  /**
   * Renvoie le thème spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `themeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  themeGet(params: {

    /**
     * Identifiant du thème
     */
    id: number;
  }): Observable<ThemeDto> {

    return this.themeGet$Response(params).pipe(
      map((r: StrictHttpResponse<ThemeDto>) => r.body as ThemeDto)
    );
  }

  /**
   * Path part for operation themePut
   */
  static readonly ThemePutPath = '/api/themes/{id}';

  /**
   * Met à jour le thème spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `themePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  themePut$Response(params: {

    /**
     * Identifiant du thème à mettre à jour
     */
    id: number;

    /**
     * Thème
     */
    body: ThemeDto
  }): Observable<StrictHttpResponse<ThemeDto>> {

    const rb = new RequestBuilder(this.rootUrl, ThemesService.ThemePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ThemeDto>;
      })
    );
  }

  /**
   * Met à jour le thème spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `themePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  themePut(params: {

    /**
     * Identifiant du thème à mettre à jour
     */
    id: number;

    /**
     * Thème
     */
    body: ThemeDto
  }): Observable<ThemeDto> {

    return this.themePut$Response(params).pipe(
      map((r: StrictHttpResponse<ThemeDto>) => r.body as ThemeDto)
    );
  }

  /**
   * Path part for operation themeDelete
   */
  static readonly ThemeDeletePath = '/api/themes/{id}';

  /**
   * Supprime le thème spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `themeDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  themeDelete$Response(params: {

    /**
     * Identifiant du thème à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ThemesService.ThemeDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le thème spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `themeDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  themeDelete(params: {

    /**
     * Identifiant du thème à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.themeDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation themePost
   */
  static readonly ThemePostPath = '/api/themes';

  /**
   * Crée le thème spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `themePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  themePost$Response(params: {

    /**
     * Thème
     */
    body: ThemeDto
  }): Observable<StrictHttpResponse<ThemeDto>> {

    const rb = new RequestBuilder(this.rootUrl, ThemesService.ThemePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ThemeDto>;
      })
    );
  }

  /**
   * Crée le thème spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `themePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  themePost(params: {

    /**
     * Thème
     */
    body: ThemeDto
  }): Observable<ThemeDto> {

    return this.themePost$Response(params).pipe(
      map((r: StrictHttpResponse<ThemeDto>) => r.body as ThemeDto)
    );
  }

}
